import { useCallback, useState } from "react";
import LazyImage from "./components/LazyImage";
import InfiniteScroll from "./components/InfiniteScroll";

import "./App.css";

const generateNewItems = (prevItems, count) => {
  return Array(count)
    .fill(0)
    .map((_, i) => prevItems.length + i + 1);
};

const App = () => {
  const [items, setItems] = useState([1, 2, 3, 4, 5]);
  /**
   * Asynchronously loads more items after a delay of 300ms.
   * Updates the state by appending 5 new items to the existing items array.
   */
  const loadMore = useCallback(() => {
    const addNewItems = () => {
      setItems((prev) => [...prev, ...generateNewItems(prev, 5)]);
    };

    setTimeout(addNewItems, 300);
  }, []);

  return (
    <div className="container">
      <h2>Section 1: Empty Box (added to give height)</h2>
      <div className="section1"></div>

      <h2>Section 2: Lazy Loading Image</h2>
      <LazyImage src="/images/isIntersecting.svg" alt="Lazy loaded image" />

      <h2>Section 3: Infinite Scrolling</h2>
      <InfiniteScroll loadMore={loadMore} hasMore={items.length < 50}>
        {items.map((item) => (
          <div
            key={item}
            style={{
              padding: "20px",
              border: "1px solid #ddd",
              margin: "10px 0",
            }}
          >
            Item {item}
          </div>
        ))}
      </InfiniteScroll>
    </div>
  );
};

export default App;
